// LOAD ALL THE READ ONLY DATA
import { toast } from "react-toastify";
import { PLANTILLAS_EMAIL_API } from "../views/MainLayout/components/shared/services/plantillasEmail";
import { makeSetReducer } from "./utils";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

export const plantillasEmailFullfilledReducer = makeSetReducer([
  "plantillas_email/fullfilled",
]);

export const fetchPlantillasEmail = () => async (dispatch) => {
  dispatch({ type: 'loading/set', payload: true })

  try {
    const response = await PLANTILLAS_EMAIL_API.get()
    const data = await response.data;
    dispatch({ type: "plantillas_email/fullfilled", payload: data });      
    const readOnly = JSON.parse(localStorage.getItem('read_only'));
    readOnly.plantillas_email = data;
    localStorage.setItem('read_only', JSON.stringify(readOnly));
  } catch (e) {
    toast.error(setErrorMessage(e))
  } finally {
    dispatch({ type: 'loading/set', payload: false })
  }
};
